export default "__VITE_ASSET__B_iY1v6v__"